// // DOMの変更を検知
export function observer() {
  // 監視対象の要素を取得
  const targetNode = document.body;
  // 監視対象の設定
  const config = { childList: true, subtree: true };
  const instance = new MutationObserver((mutationsList, observer) => {
    // DOMの変更があった場合に実行されるコールバック関数
    footerPosition()
    // 監視を終了
    observer.disconnect();
  });

  return instance.observe(targetNode, config);
}

export function footerPosition() {
  const htmlElement = document.documentElement
  const htmlHeight = htmlElement.offsetHeight
  const htmlWidth = htmlElement.offsetWidth
  const footerElement = document.getElementById('globalFooter')
  const footerHeight = footerElement ? footerElement.offsetHeight : 0
  const mainElement = document.querySelector('main');
  const mainHeight = mainElement.offsetHeight

  if (footerElement) {
    // SPサイズ
    if (htmlWidth < 769) return footerElement.style.position = ""
    // PCサイズ
    if ((htmlHeight - (mainHeight+125)) < footerHeight) {
      footerElement.style.position = "initial"
    } else {
      footerElement.style.position = "absolute"
      footerElement.style.bottom = 0
      footerElement.style.width = "100vw"
    }
  }
}
